import { render, staticRenderFns } from "./ReportSample.vue?vue&type=template&id=66e0273c&scoped=true&"
import script from "./ReportSample.vue?vue&type=script&lang=js&"
export * from "./ReportSample.vue?vue&type=script&lang=js&"
import style0 from "./ReportSample.vue?vue&type=style&index=0&id=66e0273c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e0273c",
  null
  
)

export default component.exports